import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RepresentativeEmployeeShiftActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/PeriodShift/PeriodShiftBrowser")
	}

	render() {
		return (
			<Activity 
				name="RepresentativeEmployeeShift"
				RenderedComponent={this.RenderedComponent}
				context="RepresentativeEmployeeShift"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RepresentativeEmployeeShiftActivity)
